import { Checkbox, Stack, TextField } from "@mui/material";
import moment from "moment";
import InputControl from "../../../shared/components/InputControl";
import { FTI_STATUS_OPTIONS } from "../constants";
import { FtiDatePicker } from "./FtiDatePicker";

// Filter dates are kept as "YYYY-MM-DD" strings so they survive the table state persistence
const toDate = (value) => (value ? moment(value).toDate() : null);
const toDateString = (value) =>
  value ? moment(value).format("YYYY-MM-DD") : null;

// The store filter is only rendered when `storeOptions` is given (super admin)
export const FullTaxInvoiceListFilterSection = ({
  values,
  storeOptions = null,
  onFilterChange,
}) => {
  return (
    <Stack
      direction="row"
      gap="16px"
      alignItems="center"
      flexWrap="wrap"
      flex={1}
    >
      <InputControl
        type="dropdown"
        name="status"
        options={FTI_STATUS_OPTIONS}
        value={values.status}
        onChange={(_, value) => onFilterChange({ name: "status", value })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        sx={{ width: 180 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Status"
            placeholder="~ Select ~"
            InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
          />
        )}
      />
      {storeOptions && (
        <InputControl
          type="dropdown"
          name="stores"
          multiple
          disableCloseOnSelect
          disableClearable
          options={storeOptions}
          value={values.stores}
          onChange={(_, value) => onFilterChange({ name: "stores", value })}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderTags={() => null}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.value}>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              {option.label}
            </li>
          )}
          sx={{ width: 250 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Store"
              placeholder={
                values.stores.length > 0
                  ? `${values.stores.length} selected`
                  : "~ Select ~"
              }
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
            />
          )}
        />
      )}
      <FtiDatePicker
        label="From Date"
        value={toDate(values.from_date)}
        maxDate={toDate(values.to_date) ?? undefined}
        onChange={(value) =>
          onFilterChange({ name: "from_date", value: toDateString(value) })
        }
        sx={{ width: 180 }}
      />
      <FtiDatePicker
        label="To Date"
        value={toDate(values.to_date)}
        minDate={toDate(values.from_date) ?? undefined}
        onChange={(value) =>
          onFilterChange({ name: "to_date", value: toDateString(value) })
        }
        sx={{ width: 180 }}
      />
    </Stack>
  );
};
